const BOOKING_STATUSES = [
  { text: 'Reserved', value: 'reserved', name: 'reserved' },
  { text: 'Booked', value: 'booked', name: 'booked' },
  { text: 'Cancelled by Developer', value: 'cancelled_developer', name: 'cancelled_developer' },
  { text: 'Sold', value: 'sold_spa_signed', name: 'sold_spa_signed' },
  { text: 'Waiting List', value: 'cancelled_availability', name: 'cancelled_availability', disabled: true },
  { text: 'Expired', value: 'expired', name: 'expired' },
];

export const BOOKING_STATUSES_ALL = [
  { text: 'Reserved', value: 'reserved', name: 'reserved' },
  { text: 'Booked', value: 'booked', name: 'booked' },
  { text: 'Cancelled by Developer', value: 'cancelled_developer', name: 'cancelled_developer' },
  { text: 'Waiting List', value: 'cancelled_availability', name: 'cancelled_availability' },
  { text: 'Sold', value: 'sold_spa_signed', name: 'sold_spa_signed' },
  { text: 'Expired', value: 'expired', name: 'expired' },
];

export const BOOKING_STATUSES_TABS = [
  { text: 'Total', value: 'total', name: 'total', className: 'uc-total' },
  { text: 'Reserved', value: 'reserved', name: 'reserved', className: 'uc-reserved' },
  { text: 'Booked', value: 'booked', name: 'booked', className: 'uc-booked' },
  { text: 'Sold', value: 'sold_spa_signed', name: 'sold_spa_signed', className: 'uc-sold_spa_signed' },
  { text: 'Waiting List', value: 'cancelled_availability', name: 'cancelled_availability', className: 'uc-cancelled_availability' },
  { text: 'Cancelled', value: 'cancelled_developer', name: 'cancelled_developer', className: 'uc-cancelled_developer' },
  { text: 'Expired', value: 'expired', name: 'expired', className: 'uc-expired' },
];

export const CANCELLED_BOOKING_STATUSES = [
  { text: 'Cancelled by Developer', value: 'cancelled_developer', name: 'cancelled_developer' },
  { text: 'Waiting List', value: 'cancelled_availability', name: 'cancelled_availability' },
  { text: 'Expired', value: 'expired', name: 'expired' },
];

export default BOOKING_STATUSES;

// CPI-1209 (A33/A34): Vietnam shows "Pending Cancellation" on the sales list - as a tile, as a
// filter option and as the row's status. It is a VIEW, not a seventh booking status: bookings.
// status_id stays FK-constrained to the six rows above, and a sale awaiting approval keeps the
// status it already had, so nothing that counts Reserved/Booked/Sold/Cancelled changes meaning.
// The signal is the pair of columns book-api already writes when a cancellation is requested.
export const BOOKING_STATUS_PENDING_CANCELLATION = 'pending_cancellation';

// The tile and the row flag borrow the CRM's existing pending-cancellation colour
// (src/styles/components/updatedBasicComponents.less), so no new style is introduced.
export const PENDING_CANCELLATION_STATUS = {
  text: 'Pending Cancellation',
  value: BOOKING_STATUS_PENDING_CANCELLATION,
  name: BOOKING_STATUS_PENDING_CANCELLATION,
};

export const PENDING_CANCELLATION_TAB = {
  ...PENDING_CANCELLATION_STATUS,
  className: 'uc-opportunity-pending_cancellation',
};

// "immediately before Cancelled" per the ticket. Falls back to appending if the Cancelled entry
// is ever renamed, so a rename cannot silently drop the option.
const insertBeforeCancelled = (list, item) => {
  const idx = list.findIndex(s => s.value === 'cancelled_developer');
  if (idx < 0) return [...list, item];
  return [...list.slice(0, idx), item, ...list.slice(idx)];
};

// Both helpers return the ORIGINAL array by reference when the flag is off, so Malaysia and
// Indonesia render from the identical object they render from today.
export const bookingStatusesAll = (withPendingCancellation = false) => (
  withPendingCancellation
    ? insertBeforeCancelled(BOOKING_STATUSES_ALL, PENDING_CANCELLATION_STATUS)
    : BOOKING_STATUSES_ALL
);

export const bookingStatusesTabs = (withPendingCancellation = false) => (
  withPendingCancellation
    ? insertBeforeCancelled(BOOKING_STATUSES_TABS, PENDING_CANCELLATION_TAB)
    : BOOKING_STATUSES_TABS
);

// The same predicate book-api's manage view uses (handlers/manage.go): a cancellation has been
// requested, it has not been declined, and the sale is not already cancelled. Kept here so the
// list and the tests read one definition. Both fields arrive on the row for free through
// ListBookings' Column("booking.*").
export const isBookingPendingCancellation = booking => !!(
  booking &&
  booking.pendingCancellation &&
  !booking.declinedPendingCancellationAt &&
  booking.statusID !== 'cancelled_developer' &&
  booking.statusID !== 'cancelled_availability'
);



// WEBPACK FOOTER //
// ./src/constants/bookingStatuses.js